import {Injectable} from "@angular/core";
import {Actions, Effect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {IAppState} from "../../state/app.state";


@Injectable()
export class DisplayModeEffects {
  /*
   setDisplayMode$ = createEffect( ()=>this._actions$.pipe(
     ofType<SetDisplayMode>(ESystemActions.SetDisplayMode),
     withLatestFrom(this._store$),
     switchMap(([action,storeState]) =>{
       return [
           new SetViewElementSideBarVisible(action.payload === 'desktop'),
           new SetViewElementHeaderVisible(action.payload === 'desktop')
         ];
       }
     )

   ));
 */

  constructor(
    private _actions$: Actions,
    private _store$: Store<IAppState>
  ) {}

}




